import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ElHalfYearPicker',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: 'yyyy年H'
    },
    valueFormat: {
      type: String,
      default: 'yyyy-hh'
    },
    value: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  watch: {
    value: function value(val) {
      this.changeValue(val);
    },
    readonly: function readonly(val) {
      this.canEdit = !val && this.editable;
      this.canPopover = !this.disabled && !val;
    },
    editable: function editable(val) {
      this.canEdit = !this.readonly && val;
    },
    disabled: function disabled(val) {
      this.canPopover = !val && !this.readonly;
    }
  },
  data: function data() {
    return {
      visible: false,
      showClear: false,
      canEdit: true,
      canPopover: true,
      text: '',
      viewType: 1,
      viewYear: 0,
      viewList: [],
      lineCount: 0,
      title: '',
      data: [0, 0]
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.changeValue(this.value);
    this.canEdit = !this.readonly && this.editable;
    this.canPopover = !this.disabled && !this.readonly;
    document.onkeydown = function (event) {
      if (_this.visible) {
        var data = [_this.data[0], _this.data[1]];
        if (data[0] < 1 || data[1] < 1) {
          var curDate = new Date();
          data[0] = curDate.getFullYear();
          data[1] = curDate.getMonth() < 6 ? 1 : 2;
        }
        if (event.code === 'ArrowLeft') {
          if (data[1] === 1) {
            data[0] = data[0] - 1;
            data[1] = 2;
          } else {
            data[1] = data[1] - 1;
          }
        } else if (event.code === 'ArrowRight') {
          if (data[1] === 2) {
            data[0] = data[0] + 1;
            data[1] = 1;
          } else {
            data[1] = data[1] + 1;
          }
        } else if (event.code === 'ArrowUp') {
          data[0] = data[0] - 1;
        } else if (event.code === 'ArrowDown') {
          data[0] = data[0] + 1;
        } else {
          return;
        }
        if (data[0] < 1000 || data[0] > 9999) {
          return;
        }
        _this.data = data;
        _this.viewType = 1;
        _this.viewYear = data[0];
        _this.$emit('change', _this.formatTo(data, _this.valueFormat));
      }
    };
  },
  destroyed: function destroyed() {
    document.onkeydown = null;
  },
  methods: {
    changeText: function changeText() {
      if (this.checkFormat(this.format, this.text)) {
        this.formatFrom(this.text, this.format);
        this.$emit('change', this.formatTo(this.data, this.valueFormat));
      } else {
        if (this.data[0] < 1 || this.data[1] < 1) {
          this.text = '';
        } else {
          this.text = this.formatTo(this.data, this.format);
        }
      }
      this.visible = false;
    },
    mouseEnter: function mouseEnter() {
      if (!this.disabled && !this.readonly && this.clearable && this.text !== '') {
        this.showClear = true;
      }
    },
    mouseLeave: function mouseLeave() {
      if (!this.disabled && this.clearable) {
        this.showClear = false;
      }
    },
    clear: function clear() {
      this.showClear = false;
      this.visible = false;
      this.$emit('change', '');
    },
    changeValue: function changeValue(val) {
      this.viewType = 1;
      if (val) {
        this.formatFrom(val, this.valueFormat);
        this.text = this.formatTo(this.data, this.format);
        this.viewYear = this.data[0];
      } else {
        this.text = '';
        this.data = [0, 0];
        this.viewYear = new Date().getFullYear();
      }
      this.initView();
    },
    initView: function initView() {
      var list = [];
      var curDate = new Date();
      var curYear = curDate.getFullYear();
      var curHalf = curDate.getMonth() < 6 ? 1 : 2;
      if (this.viewType === 1) {
        var halfLabels = ['上半年', '下半年'];
        for (var i = 1; i <= 2; i++) {
          var item = {
            label: halfLabels[i - 1],
            year: this.viewYear,
            half: i,
            current: false,
            active: false
          };
          if (this.viewYear === curYear && i === curHalf) {
            item.current = true;
          }
          if (this.viewYear === this.data[0] && i === this.data[1]) {
            item.active = true;
          }
          list.push(item);
        }
        this.title = this.viewYear + ' 年';
      } else {
        var start = parseInt(this.viewYear / 10) * 10;
        this.viewYear = start;
        for (var _i2 = 0; _i2 < 10; _i2++) {
          var year = start + _i2;
          var _item = {
            label: year + '',
            year: year,
            current: false,
            active: false
          };
          if (year === curYear) {
            _item.current = true;
          }
          if (year === this.data[0]) {
            _item.active = true;
          }
          list.push(_item);
        }
        this.title = start + ' 年 - ' + (start + 9) + ' 年';
      }
      this.viewList = list;
      this.lineCount = parseInt(list.length / 2);
      if (list.length % 2 > 0) {
        this.lineCount++;
      }
    },
    checkFormat: function checkFormat(pattern, val) {
      var text = '';
      var _iterator = _createForOfIteratorHelper(pattern),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var char = _step.value;
          var dict = '\\^$.+?*[]{}!';
          if (dict.indexOf(char) === -1) {
            text += char;
          } else {
            text += '\\' + char;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      text = text.replace('yyyy', '[1-9]\\d{3}');
      text = text.replace('hh', '0[1-2]');
      text = text.replace('h', '[1-2]');
      text = text.replace('H', '[上下]半年');
      text = '^' + text + '$';
      var patt = new RegExp(text);
      return patt.test(val);
    },
    formatTo: function formatTo(data, pattern) {
      var text = pattern.replace('yyyy', '' + data[0]);
      text = text.replace('hh', '0' + data[1]);
      text = text.replace('h', '' + data[1]);
      text = text.replace('H', data[1] === 1 ? '上半年' : '下半年');
      return text;
    },
    formatFrom: function formatFrom(str, pattern) {
      var year = this.findText(str, pattern, 'yyyy');
      var half = this.findText(str, pattern, ['hh', 'h', 'H']);
      this.data = [year, half];
    },
    findText: function findText(str, pattern, find) {
      if (find instanceof Array) {
        var _iterator2 = _createForOfIteratorHelper(find),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var f = _step2.value;
            var _val = this.findText(str, pattern, f);
            if (_val !== -1) {
              return _val;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return -1;
      }
      var index = pattern.indexOf(find);
      if (index === -1) {
        return index;
      }
      var val = str.substr(index, find.length);
      if (find === 'H') {
        return val === '上半年' ? 1 : 2;
      } else {
        return parseInt(val);
      }
    },
    clickYear: function clickYear() {
      if (this.viewType !== 1) {
        return;
      }
      this.viewType = 2;
      this.initView();
    },
    clickItem: function clickItem(item) {
      if (this.viewType === 1) {
        this.$emit('change', this.formatTo([item.year, item.half], this.valueFormat));
        this.visible = false;
      } else {
        this.viewType = 1;
        this.viewYear = item.year;
        this.initView();
      }
    },
    clickLast: function clickLast() {
      if (this.viewYear > 1000) {
        if (this.viewType === 1) {
          this.viewYear--;
          this.initView();
        } else {
          this.viewYear = this.viewYear - 10;
          this.initView();
        }
      }
    },
    clickNext: function clickNext() {
      if (this.viewYear < 9999) {
        if (this.viewType === 1) {
          this.viewYear++;
          this.initView();
        } else {
          this.viewYear = this.viewYear + 10;
          this.initView();
        }
      }
    }
  }
};